<fieldset>
    <legend *ngIf="legend" [align]="legendAlign">{{legend}}</legend>
    <box class="fieldset-group">
        <ng-content #content></ng-content>
    </box>
</fieldset>